
import { initializeApp } from 'firebase/app';
import { getMessaging, getToken, onMessage, isSupported } from "firebase/messaging";
import { logger } from "../utils/Logger";
import Config from '../chat/models/Config';
import PushHandler from '../chat/network/PushHandler';
import { getCookie } from '../network/cookie';

const FIREBASE_CONFIG = {
    apiKey: "AIzaSyDi8BSg5aVy95EMFONvYNmhU7dIKowadbE",
    authDomain: "myt-student-mobile.firebaseapp.com",
    databaseURL: "https://myt-student-mobile.firebaseio.com",
    projectId: "myt-student-mobile",
    storageBucket: "myt-student-mobile.appspot.com",
    messagingSenderId: "401802094788",
    appId: "1:401802094788:web:56699853c1fd1aae"
}

export default class MytNotification {

    private static askedPushPermission = false;
    private static serviceWorkerRegistered = false;

    private static fetchToken = async () => {
        if (window.location.hostname.includes("local")) {
            return
        }

        const hridayaServiceWorkerPath = '/static/js/service_worker.js';
        const chatServiceWorkerPath = '/web-chat-ssr/js/service_worker.js';

        const registerPath = window.location.hostname.includes('hridaya') ? hridayaServiceWorkerPath : chatServiceWorkerPath

        try {
            const serviceWorkerRegistration = await navigator.serviceWorker.register(registerPath);

            const app = initializeApp(FIREBASE_CONFIG);
            const messaging = getMessaging(app);

            onMessage(messaging, (payload) => {
                logger.debug('MytNotification received. ', payload);
            });

            const currentToken = await getToken(messaging, {
                serviceWorkerRegistration: serviceWorkerRegistration
            });

            if (!!currentToken) {
                Config.shared.updatePushToken(currentToken)
            }

            if (Config.shared.cached().syncFcmPushToken) {
                PushHandler.shared.registerPush(currentToken);
            }
        } catch (err) {
            logger.debug('MytNotification: An error occurred while retrieving token. ', err);
        }
    };

    private static requestPermissionForPushNotification = () => {
        if (MytNotification.askedPushPermission) {
            return;
        }

        if (Notification.permission === "granted") {
            this.fetchToken();
        } else if (Notification.permission !== "denied") {
            MytNotification.askedPushPermission = true;

            Notification.requestPermission().then((permission) => {
                // If the user accepts, let's create a notification
                if (permission === "granted") {
                    this.fetchToken();
                }
            });
        } else {
            logger.debug('MytNotification: Unable to get permission to notify.');
        }
    };

    static webPushInit = () => {
        if (getCookie("is_impersonated") === "true" || getCookie("impersonationFromTeacherToken")) {
            // no push token for impersonated student
            return
        }

        if (!("Notification" in window)) {
            return "This browser does not support desktop notification";
        }

        if ('serviceWorker' in navigator && 'PushManager' in window) {
            if (MytNotification.serviceWorkerRegistered) {
                return;
            }

            isSupported().then((supported) => {
                if (supported) {
                    this.requestPermissionForPushNotification();
                }
            })
        }
    };

    static showLocalNotification = (
        notificationTag: string,
        notificationBody: string = 'You got a new message',
        onClick?: ((notificationTag: string) => void)) => {
        if (!document.hidden &&
            'Notification' in window &&
            Notification.permission === 'granted') {

            const notificationTitle = 'MyYogaTeacher';
            const notificationOptions = {
                body: notificationBody,
                icon: '/static/images/notification_icon_256.png',
                badge: '/static/images/notification_icon_128.png',
                vibrate: [500, 110, 500, 110, 450, 110, 200, 110, 170, 40, 450, 110, 200, 110, 170, 40, 500],
                sound: '/static/sounds/notification.wav',
                tag: notificationTag,
            };

            const notification = new Notification(notificationTitle, notificationOptions);
            notification.onclick = () => {

                if (!!window) {
                    window.focus();
                }

                onClick?.(notificationTag);
                notification.close();
            };
        }
    };
}